import {TOAST_SHOW, TOAST_CLOSE} from '../actions/toast';

export default function toastReducer(state = {visible: false}, action) {
    switch (action.type) {
        case TOAST_SHOW:
            return action.toast;

        case TOAST_CLOSE:
            return {
                ...state,
                visible: false,
            };

        default:
            return state;
    }
}
